import { KYMW2600Model } from '../kymw2600.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

 /**
 * Ｗ掲載リスト取得
 *
 * @export
 * @class GetWPlaceListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetWPlaceListService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW2600Model;
  private successFunc: Function;

  vo = {
      OrderCode : '',
      CoopCode : '',
      ClassCode : '',
    };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetWPlaceListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode,
        CoopCode: this.vo.CoopCode,
        ClassCode: this.vo.ClassCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetWPlaceListService
   */
  execute(model, vo, successFunc: Function = null): void {
      this.model = model;
      this.vo = vo;
      this.successFunc = successFunc;
      this.send('getWPlaceList', this.getBody());
    }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetWPlaceListService
   */
  success(data: any): void {
      if (data !== null) {
          this.successFunc(data);
        }
    }
}
